import React from 'react'
import {DataObjectId, Hub, StickerType, Tag} from 'yougile-model'
import {Sync} from '@client/sync'
import {Icon} from '@components/common/base/icon'
import {WithBackground} from '@components/common/base/sticker'
import {
  getStateColor,
  getStatesList
} from '@components/sticker/sticker-menu/sticker-menu-string/utils'
import {SprintCtl} from '@extensions/sticker/controllers/sprint-ctl'
import {
  Sticker as StickerExtension,
  Sticker as StickerExtention
} from '@extensions/sticker/sticker'
import {CustomStickerMenuMultiActions} from '@extensions/sticker/views-web/customStickerMultiActions/custom-sticker-menu-multi-actions'

interface StickerStringMultipleMenu {
  sticker: Tag
  task: Hub
  stickerType: StickerType
  tasksFromMultiActions: DataObjectId[]
  cb: () => void
  onUnpin: () => void
}
// eslint-disable-next-line unused-imports/no-unused-vars
export const StickerStringMultipleMenu = ({
  sticker,
  stickerType,
  task,
  cb,
  tasksFromMultiActions,
  onUnpin
}: StickerStringMultipleMenu) => {
  const allStates = getStatesList(sticker)

  const unpin = () => {
    StickerExtention.unpin(sticker, task)

    const box = Sync.getCurrentSandbox()
    for (const id of tasksFromMultiActions) {
      const task = box.getHub(id)
      if (!task || !sticker) {
        continue
      }
      StickerExtention.unpin(sticker, task)
    }

    cb()
    onUnpin?.()
  }

  const stickerValues = allStates.map(stickerState => {
    const onClick = () => {
      StickerExtention.pin(sticker, 'stats', task, stickerState.id)
      cb()
    }
    const stateColor = getStateColor(
      sticker.states.index[stickerState.id],
      stickerType
    )
    const isSprintSticker = stickerType === 'sprint'
    const stickerIcon = StickerExtension.getIcon(sticker)

    return (
      <div
        className="flex p-4 cursor-pointer hover:bg-action-default group"
        key={stickerState.id}
        onClick={onClick}
      >
        {!isSprintSticker && stickerIcon && (
          <div className="flex items-center">
            <WithBackground backgroundColor={`icon-${stateColor}`}>
              <Icon color={`icon-${stateColor}`} icon={stickerIcon} />
            </WithBackground>
          </div>
        )}
        <div className="ml-4 text-main-old text-14 group-hover:text-on-color">
          {stickerState.name}{' '}
          {isSprintSticker && (
            <span className="font-semibold">
              {SprintCtl.formatInterval(stickerState)}
            </span>
          )}
        </div>
      </div>
    )
  })

  return (
    <CustomStickerMenuMultiActions
      stickerValues={stickerValues}
      cb={cb}
      unpin={unpin}
    />
  )
}
